<template>
    <form @submit.prevent="validate" >
        <b-field label="Clef cible qui va changer">
            <b-autocomplete
                    v-model="clef"
                    :data="data"
                    :loading="isFetching"
                    @typing="getAsyncData"
                    @select="option => selected = option"
                    ref="startFocus">
                <template slot="empty">...</template>
            </b-autocomplete>
        </b-field>
        <b-field label="La valeur :">
            <b-input v-model="valeur"></b-input>
        </b-field>
        <b-button  type="is-info"  native-type="submit">AJOUTER</b-button>
        <hr>
    </form>

</template>

<script>

    import Carac from '../../classes/Carac.js'
    import _ from 'lodash';

    export default {
        name: 'addcarac',
        data (){
            return {
                clef:'',
                valeur:'',

                data:[],
                name: '',
                selected: null,
                isFetching: false
            }
        },
        components: {},
        props: ['letype','lieu','open'],
        computed: {
            filteredDataArray() {
                this.result()
                return this.data.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.name.toLowerCase()) >= 0
                })
            },
        },
        methods: {
            async getAsyncData(){
                this.isFetching = true
                this.data=[]
                if(this.clef.length>0)
                {
                    const resu=await this.$mydb.do.searchBegin(this.clef)
                    let tmp=[]
                    resu.forEach((item) => tmp.push(item.clef))
                    this.data=_.uniq(tmp)
                }
                this.isFetching = false
            },

            validate(){
                const carac=new Carac(this.letype,this.lieu,this.clef,this.valeur)
                this.$emit('validated', carac)
                this.clef = ''
                this.valeur = ''
            }

        },
        mounted(){

        },
        watch: {
            open(newvalue) {
                if(newvalue) this.$refs['startFocus'].focus();
            }
        }
    }

</script>


<style lang="scss">

    .myLabel{
        display:inline-block;
    }

    .lineField{
        width:100%;
        height:auto;
    }
</style>